import { Card, Grid } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    //
  },
}));

export const ContainerStyled = styling(Card)((props) => ({
  display: "flex",
  flexDirection: "column",
  padding: "36px",
  marginBottom: "30px",

  p: {
    margin: "0px",
  },

  [props.theme.breakpoints.down(1280)]: {
    padding: "20px 10%",
  },

  [props.theme.breakpoints.down(768)]: {
    padding: "20px 5%",
  },
}));

export const GridStyled = styling(Grid)({
  maxWidth: "1280px",
  margin: "auto",
  padding: "0 5%",
});
